import type { Database } from '@storytune/chat-core/shared-types/database'

let databaseAccessor: (() => Database) | undefined

export function registerAlertDatabaseAccessor(accessor: () => Database): void {
  databaseAccessor = accessor
}

export function getAlertDatabase(): Database | undefined {
  return databaseAccessor?.()
}
